import React from 'react';
export function EyeShowIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.944 11.672A10.349 10.349 0 0012 5a10.349 10.349 0 00-9.944 6.672.984.984 0 000 .656A10.349 10.349 0 0012 19a10.35 10.35 0 009.944-6.672.984.984 0 000-.656zM12 17a8.4 8.4 0 01-7.933-5A8.4 8.4 0 0112 7a8.4 8.4 0 017.933 5A8.4 8.4 0 0112 17z"
  }));
}